export default __webpack_public_path__ + "static/media/slider-img22.7a3120c7.jpg";